import React, { useState } from 'react';
import { Button, Menu, MenuItem, ListItemIcon, makeStyles } from '@material-ui/core';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

const useStyles = makeStyles({
  menuItem: {
    paddingTop: 10,
    paddingBottom: 10,
    fontFamily: 'canalfont-regular',
  },
  selectedItem: {
    backgroundColor: '#E0E0E0 !important',
  },
  icon: {
    minWidth: 36,
    color: '#6200EE',
  },
  uncheckedIcon: {
    minWidth: 36,
    color: '#6200EE',
    opacity: 0.6,
  },
});

function PredefinedViewsButton({ onChange, currentView }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const views = [
    { label: 'Toutes', value: 'ALL' },
    { label: 'À venir', value: 'UPCOMING' },
    { label: 'En cours', value: 'ONGOING' },
  ];

  const currentViewLabel =
    currentView === 'SEARCH'
      ? 'Filtrer les campagnes'
      : {
          ALL: 'Toutes les campagnes',
          UPCOMING: 'Campagnes à venir',
          ONGOING: 'Campagnes en cours',
        }[currentView] || 'Toutes les campagnes';

  return (
    <>
      <Button
        style={{ color: '#6200EE', fontFamily: 'canalfont-regular' }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        startIcon={<VisibilityOutlinedIcon style={{ color: '#6200EE' }} />}
      >
        {currentView === 'SEARCH' ? 'Filtrer les campagnes' : `Filtre : ${currentViewLabel}`}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        getContentAnchorEl={null}
        PaperProps={{
          style: {
            marginTop: 8,
          },
        }}
      >
        {views.map((v) => {
          const selected = currentView === v.value;
          return (
            <MenuItem
              key={v.value}
              onClick={() => {
                onChange(v.value);
                setAnchorEl(null);
              }}
              className={`${classes.menuItem} ${selected ? classes.selectedItem : ''}`}
            >
              <ListItemIcon className={selected ? classes.icon : classes.uncheckedIcon}>
                {selected ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}
              </ListItemIcon>
              {v.label}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}

export default PredefinedViewsButton;
